<template>
    <div>
        <div>
            <canvas v-bind="canvasAttrs" id="nqt-pdf"></canvas>
        </div>
    </div>
</template>

<script>
    import PDFJS from "pdfjs-dist";

    export default {
        name: "nqt-pdf",
        props: {
            pdfurl: {
                type: Number,
            },
            firstPage: {
                type: Number
            },
            value: {
                type: Number,
                default: 0,
            },
        },
        data() {
            return {
                pdf: null,
                zoom: 0,
                page: 1,
                widthDefault: 0,
                pxTop: 0,
                isInit: false,
                width: 0,
                left: 0
            };
        },
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
            canvasAttrs() {
                // Resize top
                const style = `top: ${this.pxTop}px; left: ${this.left}px; `;
                return {
                    style,
                };
            },
        },
        created() {
            this.load(this.firstPage, true);
        },
        mounted () {
            const self = this;
            document.getElementsByTagName("BODY")[0].onresize = function() {
                self.reload();
            };
        },
        updated() {
            let osw = Number(document.getElementById("div-right").offsetWidth);
            let left = (osw - this.width) / 2;
            this.left = left >= 0 ? left : 0;
        },
        watch: {
            value(v) {
                // Nếu là PC và Mobile ở chế độ ngang thì + 45
                if (!this.mobile || (this.mobile && window.orientation == 90)) {
                    v = v != 0 ? v + 45 : v;
                }

                // Nếu là mobile ở chế độ thẳng đứng thì +160
                if (this.mobile && window.orientation == 0) {
                    v = v != 0 ? v + 190 : v;
                }

                let zoom = 0;
                let scale = v / 5;
                scale = scale * 20;
                zoom = zoom + scale * 0.25;

                this.zoom = v == 0 ? 0 : zoom;

                // Bỏ check lần đầu
                this.isInit = false;

                // Hiển thị PDF theo số zoom
                this.displayPage(this.pdf, this.page);
            },
        },
        methods: {
            // Hiển thị pdf lên canvas
            renderPage: function (page) {

                let offsetWidth = Number(document.getElementById("div-right").offsetWidth);
                let offsetHeight = Number(document.getElementById("div-right").offsetHeight);

                let widthPct = (offsetWidth * this.zoom) / 100;
                let width = offsetWidth + widthPct;

                if (this.value == 0 && !this.isInit) {
                    width = this.widthDefault;
                }

                let scale = width / page.view[2];

                let height = page.view[3] * scale;

                // Tính px top
                let pxTopDefault = (offsetHeight - height) / 2;
                let pxDesc = this.zoom * 10;
                let top = pxTopDefault - pxDesc;
                this.pxTop = top >= 0 ? top : 0;
	
                // Nếu pdf là dạng A4 thì sẽ set lại width
                if (pxTopDefault <= 0) {
                    offsetWidth = offsetWidth - 17;

                    widthPct = (offsetWidth * this.zoom) / 100;
                    width = offsetWidth + widthPct;

	                if (this.value == 0 && !this.isInit) {
                    	width = this.widthDefault;
                	}	

                    scale = width / page.view[2];

                    height = page.view[3] * scale;
                }

                if (this.isInit) {
                    this.widthDefault = width;
                }

                // Tạo canvas
                let canvas = document.getElementById("nqt-pdf");
                canvas.width = width;
                canvas.height = height;

                this.width = width;

                // Lấy viewport theo scale đã tính
                let viewport = page.getViewport(scale);

                // Lấy Context của canvas
                let context = canvas.getContext("2d");

                let renderContext = {
                    canvasContext: context,
                    viewport: viewport,
                };

                // Hiển thị
                let renderTask = page.render(renderContext);

                // Wait for rendering to finish
                renderTask.promise
                    .then(function () {})
                    .catch(function () {
                        // self.displayPage(self.pdf, self.page);
                    });
            },
            displayPage: function (pdf, num) {
                const self = this;
                pdf.getPage(num).then(function getPage(page) {
                    self.renderPage(page);
                });
            },
            load: async function (page, isInit) {
                // Lấy blob pdf từ api
                let pdfBlob = await this.getPdf(this.pdfurl);

                // Chuyển đổi từ url sang blob
                const blob = this.dataURItoBlob(pdfBlob);
                const urls = URL.createObjectURL(blob);

                PDFJS.getDocument(urls)
                    .then((pdf) => {
                        // Hiển thị PDF
                        this.displayPage(pdf, page);

                        // Lần đầu
                        this.isInit = isInit;
                        this.page = page;

                        // Gán lại obj
                        this.pdf = pdf;

                        this.$emit("loadPDF", true);
                    })
                    .catch((error) => {
                        this.$emit("loadPDF", false);
                    });
            },
            getPdf: function (url) {
                return new Promise((resolve) => {
                    this.$api
                        .post("/courseStudy/getCourseMaterialObject", {
                            courseMaterialId: url,
                        })
                        .then((response) => {
                            resolve(response.data.blob);
                        })
                        .catch((err) => {});
                });
            },
            jump(page) {
                // Hiển thị PDF theo trang
                this.displayPage(this.pdf, page);

                // Bỏ check lần đầu
                this.isInit = false;

                // Lưu lại trang hiện tại
                this.page = page;
            },
            reload: function () {
                // Tải lại trình chiếu pdf khi thay đổi màn hình
                this.zoom = 0;
                this.load(this.page, true);
            }
        },
    };
</script>

<style scoped>
    .disable {
        opacity: 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/schedule/nqtPdf.vue